import Cookie from 'js-cookie'
export default {
	methods: {
		// 表格
		getRowClass({ row, rowIndex, columnIndex }) {
			if (rowIndex === 0) {
				if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
					return 'background:#EAF0F5'
				} else {
					return 'background:#D6E3E8'
				}
			}
			return ''
		},
		handleCheck(row, link) {
			this.$router.push({
				path: `${link}`
			})
			Cookie.set('row', JSON.stringify(row))
		},
	}
}
